export default "__VITE_ASSET__ZD0DZA8K__"